import { useParams } from "react-router-dom";

import HomeFooter from "../Component/HomeComponent/HomeFooter";

import { useState, useEffect } from "react";
import { Space, Col, Row, Spin } from "antd";
import { useLocation } from "react-router-dom";
import HomeHeader from "../Component/HomeComponent/HomeHeader";

import ReactPlayer from "react-player";
import {
  TitleContainer,
  PageContainer,
  FirstSectionContainer,
  DetailsContainer,
  SubPageTitle,
  SectionContainer,
  SeperatorImage,
  ClientLogo,
} from "../Component/HomeComponent/GeneralComponents";
import TransparentCard from "../Component/HomeComponent/TransparentCard";
import SubPageDetails from "../Component/HomeComponent/SubPageDetails";
import ArrowCarousel from "../Component/HomeComponent/ArrowCarousel";
import InformationCard from "../Component/HomeComponent/InformationCard";
import { gql, useQuery, useLazyQuery } from "@apollo/client";
import { getUrl } from "aws-amplify/storage";

const defaultData = {
  title: "-",
  image: "-",
  link: "-",
  client_img: [],
  location: "-",
  sector: "-",
  introduction: [],
  showcase: ["null"],
  separate_bg: ["null"],
  outcome: [
    {
      img: "-",
      title: "-",
      link: "-",
      content: "-",
    },
  ],
};

const GET_DISPLAY_PROJECTS = gql`
  query GetDisplayProjects($link: String!) {
    home_page_project(where: { link: { _eq: $link } }) {
      id
      title
      image
      link
      client_img
      location
      sector
      introduction
      showcase
      separate_bg
    }
  }
`;

const GET_PROJECT_OUTCOME = gql`
  query GetProjectOutcome($id: uuid!) {
    home_page_project_outcome(where: { home_page_project_id: { _eq: $id } }) {
      id
      img
      title
      link
      content
    }
  }
`;

const GET_PROJECTS = gql`
  query GetProjects {
    home_page_project {
      id
      title
      image
      link
    }
  }
`;

export default function HomeProject() {
  let { page } = useParams();
  const [ismobile, setIsMobile] = useState(0);
  const [key, setKey] = useState(0);
  const location = useLocation();
  const { loading, data: projectData } = useQuery(GET_DISPLAY_PROJECTS, {
    variables: { link: `/home_project/${page}` },
  });
  const { data: projectListData } = useQuery(GET_PROJECTS);
  const [getProjectOutcome, { data: projectOutcomeData }] = useLazyQuery(
    GET_PROJECT_OUTCOME,
    {
      variables: { id: projectData?.home_page_project[0]?.id },
      fetchPolicy: "network-only",
    }
  );
  const [data, setData] = useState(defaultData);
  const [otherProjects, setOtherProjects] = useState([]);

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 10);
    setKey((prevKey) => prevKey + 1);
  }, [location]);
  useEffect(() => {
    const handleResize = () =>
      setIsMobile(window.innerHeight > window.innerWidth ? 1 : 0);
    window.addEventListener("resize", handleResize);
    // Call handleResize right away so that ismobile is set correctly initially
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const getS3Url = async (path) => {
    if (!path || !path.startsWith("websitePicture/")) return path;
    try {
      const { url } = await getUrl({
        key: path,
        options: {
          expiresIn: 3600,
        },
      });
      return url.href;
    } catch (error) {
      console.error("Fetch S3 URL failed:", error);
      return path;
    }
  };

  useEffect(() => {
    const processS3Urls = async (rawData) => {
      if (!rawData) return defaultData;

      try {
        const processedImage = await getS3Url(rawData.image);

        const processedClientImages = await Promise.all(
          (rawData.client_img || []).map((img) => getS3Url(img))
        );

        const processedShowcaseImages = await Promise.all(
          (rawData.showcase || []).map(async (img) => {
            if (img.includes("youtu.be")) {
              return img;
            } else {
              return await getS3Url(img);
            }
          })
        );

        const processedSeparateBg = await Promise.all(
          (rawData.separate_bg || []).map((img) => getS3Url(img))
        );

        return {
          ...rawData,
          image: processedImage,
          client_img: processedClientImages,
          showcase: processedShowcaseImages,
          separate_bg: processedSeparateBg,
        };
      } catch (error) {
        console.error("Processing S3 request failed:", error);
        return rawData;
      }
    };

    const updateData = async () => {
      if (projectData?.home_page_project[0]) {
        const processedData = await processS3Urls(
          projectData.home_page_project[0]
        );
        setData(processedData);

        if (processedData.id) {
          getProjectOutcome();
        }
      } else {
        setData(defaultData);
      }
    };

    updateData();
  }, [projectData, page, getProjectOutcome]);

  // Process S3 URLs for project outcomes
  useEffect(() => {
    const processOutcomeUrls = async () => {
      if (!projectOutcomeData?.home_page_project_outcome) return;

      try {
        const processedOutcome = await Promise.all(
          projectOutcomeData.home_page_project_outcome.map(async (outcome) => ({
            ...outcome,
            img: await getS3Url(outcome.img),
          }))
        );
        console.log("Processed outcome:", processedOutcome);
        setData((prevData) => ({
          ...prevData,
          outcome: processedOutcome,
        }));
      } catch (error) {
        console.error("Processing outcome S3 URLs failed:", error);
      }
    };

    processOutcomeUrls();
  }, [projectOutcomeData]);

  useEffect(() => {
    const fetchProjectList = async () => {
      if (projectListData?.home_page_project) {
        const processedProjects = await Promise.all(
          projectListData.home_page_project.map(async (project) => {
            const processedImage = await getS3Url(project.image);
            return {
              ...project,
              image: processedImage,
            };
          })
        );
        setOtherProjects(processedProjects);
      }
    };

    fetchProjectList();
  }, [projectListData]);

  return (
    <PageContainer key={key}>
      <HomeHeader />
      <Spin spinning={loading} fullscreen />
      <div>
        <FirstSectionContainer ismobile={ismobile} bg={data.image}>
          <TitleContainer ismobile={ismobile}>{data.title}</TitleContainer>
          <DetailsContainer ismobile={ismobile}>
            <Space
              direction="vertical"
              size="small"
              style={{
                width: ismobile ? "70vw" : "33vw",
                fontSize: "inherit",
              }}
            >
              <div style={{ display: "flex" }}>
                <div>
                  <Row style={{ paddingBottom: "3vh", fontSize: "inherit" }}>
                    <Col
                      span={24}
                      style={{
                        fontWeight: 900,
                        fontSize: "inherit",
                      }}
                    >
                      Client:{" "}
                    </Col>
                    <Col
                      span={24}
                      style={{
                        fontSize: "inherit",
                        display: "flex",
                        flexDirection: "column",

                        alignItems: "flex-start",
                      }}
                    >
                      {data.client_img.map((client, index) => {
                        return (
                          <ClientLogo
                            key={index + client}
                            src={client}
                            alt={client}
                          />
                        );
                      })}
                    </Col>
                  </Row>
                </div>
                <div style={{ paddingBottom: "3vh" }}>
                  <Row style={{ paddingBottom: "3vh", fontSize: "inherit" }}>
                    <Col
                      span={24}
                      style={{
                        fontWeight: 900,
                        fontSize: "inherit",
                      }}
                    >
                      Location:{" "}
                    </Col>
                    <Col span={24} style={{ fontSize: "inherit" }}>
                      {data.location}
                    </Col>
                  </Row>
                  <Row style={{ paddingBottom: "3vh", fontSize: "inherit" }}>
                    <Col
                      span={24}
                      style={{
                        fontWeight: 900,
                        fontSize: "inherit",
                      }}
                    >
                      Sector:{" "}
                    </Col>
                    <Col span={24} style={{ fontSize: "inherit" }}>
                      {data.sector}
                    </Col>
                  </Row>
                </div>
              </div>
              <div style={{ paddingBottom: "3vh" }}>
                {data.introduction.map((intro, index) => {
                  return (
                    <SubPageDetails
                      key={index + intro}
                      ismobile={ismobile}
                      style={{ width: "100%", paddingBottom: "2vh" }}
                    >
                      {intro}
                    </SubPageDetails>
                  );
                })}
              </div>
            </Space>
          </DetailsContainer>
        </FirstSectionContainer>
        <SubPageTitle ismobile={ismobile} style={{ paddingBottom: 0 }}>
          Gallery
        </SubPageTitle>
        <div style={ismobile ? gridContainerMobile : gridContainer}>
          {data.showcase.map((showcase, index) => {
            if (showcase.includes("youtu.be")) {
              return (
                <div
                  key={index}
                  style={{
                    gridColumn: "1 / -1",
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: ismobile ? 0 : "5vh",
                  }}
                >
                  <ReactPlayer
                    url={showcase}
                    playsinline
                    muted
                    controls
                    playing
                    height={ismobile ? "auto" : "80vh"}
                    width={ismobile ? "80vw" : "auto"}
                    style={{
                      aspectRatio: "16/9",
                      maxWidth: "100%",
                    }}
                    loop
                  />
                </div>
              );
            } else {
              return (
                <div
                  key={index}
                  style={{
                    width: "100%",
                    aspectRatio: "1",
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  <img
                    alt="showcase"
                    src={showcase}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "center",
                    }}
                  />
                </div>
              );
            }
          })}
        </div>

        <SeperatorImage bg={data.separate_bg[0]} ismobile={ismobile} />
        <SubPageTitle ismobile={ismobile}> Deliverables</SubPageTitle>
        <Row
          justify="center"
          style={{
            paddingLeft: "4vw",
            paddingRight: "4vw",
            paddingTop: "5vh",
          }}
        >
          {data?.outcome?.map((option, index) => {
            return (
              <Col
                span={ismobile ? 20 : 8}
                style={{
                  paddingBottom: "5vh",
                  paddingLeft: ismobile ? 0 : "1vw",
                  paddingRight: ismobile ? 0 : "1vw",
                }}
                key={option.title + index}
              >
                <InformationCard
                  option={option}
                  isVisible={true}
                  delay={0.25 * index}
                  hovermode={true}
                />
              </Col>
            );
          })}
        </Row>

        <SeperatorImage
          bg={data.separate_bg[Math.min(1, data.separate_bg.length - 1)]}
          ismobile={ismobile}
        />
        <SectionContainer>
          <SubPageTitle ismobile={ismobile} style={{ paddingTop: "15vh" }}>
            More of Our Work
          </SubPageTitle>

          <ArrowCarousel
            more={true}
            ismobile={ismobile}
            style={{
              display: "flex",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {otherProjects.map((project, index) => {
              if (project.link.split("/").pop() !== page) {
                return (
                  <div>
                    <TransparentCard
                      option={project}
                      key={index + project.title}
                    />
                  </div>
                );
              } else {
                return null;
              }
            })}
          </ArrowCarousel>
        </SectionContainer>
        <HomeFooter />
      </div>
    </PageContainer>
  );
}

const gridContainer = {
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "2px",
  padding: "5vh 5vw",
  width: "89vw",
};

const gridContainerMobile = {
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: "5px",
  padding: "2vh 10vw",

  width: "89vw",
};
